import { createContext, useContext } from 'react';

export type ReportedRequests = Pick<Set<string>, 'has' | 'add'>;

export function createReportedRequests(): ReportedRequests {
  return new Set<string>();
}

const ReportedRequestsContext = createContext<ReportedRequests | undefined>(undefined);

export const ReportedRequestsProvider = ReportedRequestsContext.Provider;

export function useReportedRequests(): ReportedRequests {
  const reportedRequests = useContext(ReportedRequestsContext);
  if (reportedRequests === undefined) {
    throw new Error('useReportedRequests must be used inside ReportedRequestsProvider');
  }
  return reportedRequests;
}
